export const administrationHeader = {
    display: "flex",
    minHeight: "70px",
    paddingLeft: "30px",
    paddingRight: "20px",
    alignItems: "center",
    justifyContent: "space-between",

    fontSize: "20px",
    fontWeight: "600",

    /* 🔥 NEW */
    background: "linear-gradient(180deg, rgba(255,255,255,0.85), rgba(255,255,255,0.65))",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",

    borderBottom: "1px solid rgba(0,0,0,0.06)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",

    //borderRadius: "10px",
    margin: "0px"
};

export const menuButton = {
  display: "flex",
  height: "32px",              // +2px feels more deliberate
  width: "150px",
  alignItems: "center",
  justifyContent: "space-around",
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: 500,
  cursor: "pointer",

  background: "linear-gradient(180deg, #2f8edc 0%, #1f6fb8 100%)",

  boxShadow:
    "0 2px 4px rgba(0,0,0,0.18), 0 4px 8px rgba(0,0,0,0.12)",

  borderRadius: "6px",          // softer, more modern
  marginLeft: "6px",
  userSelect: "none",
  transition: "all 0.15s ease-in-out"
};

export const menuButtonHover = {
  background: "linear-gradient(180deg, #3698ea 0%, #257ccf 100%)",
  boxShadow:
    "0 4px 8px rgba(0,0,0,0.22), 0 6px 12px rgba(0,0,0,0.18)"
};

export const menuButtonCancel = {
  ...menuButton,
  background: "#ffffff",
  color: "#1f6fb8",
  border: "1px solid #d1d5db",
  boxShadow: "none"
};

export const menuButtonDanger = {
  ...menuButton,
  background: "linear-gradient(180deg, #e5533d 0%, #c63b28 100%)"
};

export const menuButtonCancelHover = {
  background: "#f9fafb"
};

export const menuButtonDangerHover = {
  background: "linear-gradient(180deg, #ec6048 0%, #d13f2b 100%)"
};